import React from 'react';

import styles from './Faq.module.scss';

import { Col, Row, Banner } from 'darrius';

type TQuestions = {
  question: string;
  answer: string;
};

export interface IFaqProps {
  /**
   * Faq title
   */
  title?: string;
  /**
   * Faq questions
   */
  questions?: TQuestions[];
}

export const Faq = ({ questions = [], title }: IFaqProps) => {
  if (!questions.length) {
    return <></>;
  }

  return (
    <Banner
      size="2"
      icon="faq"
      className={styles['faq-container']}
      title={title}
    >
      <Row>
        <Col>
          {questions.map(
            (faq) =>
              faq.question &&
              faq.answer && (
                <div
                  className={`${styles.post} ${styles.bordered}`}
                  key={faq.question}
                >
                  <div className={styles.paragraph}>
                    <h2>{faq.question}</h2>
                    <div
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{
                        __html: faq.answer,
                      }}
                    />
                  </div>
                </div>
              )
          )}
        </Col>
      </Row>
    </Banner>
  );
};
